"use client";
import * as React from "react";
const SvgFavoriteRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M9.08 13.59a1.6 1.6 0 0 1-2.15 0l-.09-.09C2.64 9.73-.1 7.27 0 4.2A4.3 4.3 0 0 1 1.87.79 4.66 4.66 0 0 1 8 1.66a4.65 4.65 0 0 1 6.13-.87A4.3 4.3 0 0 1 16 4.19c.1 3.08-2.64 5.55-6.84 9.33z" }));
export {
  SvgFavoriteRound as default
};
